import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addGender, deleteGender, getAllGender, updateGender } from '../../redux/rtk/features/masters/genderSlice';
import PageTitle from '../page-header/PageHeader';

const GenderMaster = () => {
  const { Title } = Typography;
  const [editingGender, setEditingGender] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.gender);

  useEffect(() => {
    dispatch(getAllGender());
  }, [dispatch]);

  

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingGender) {
        // Update existing gender
        const result = await dispatch(
          updateGender({ id: editingGender.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllGender());
        } else {
          message.error('Error updating gender!');
        }
      } else {
        // Add new gender
        const result = await dispatch(addGender(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllGender());
        } else {
          message.error('Error adding gender!');
        }
      }
      setEditingGender(false);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update gender!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteGender(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllGender()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Gender',
      dataIndex: 'gender',
      key: 'gender',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() =>{ setEditingGender(record); form.setFieldsValue(record)}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this gender?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingGender ? 'Edit Gender' : 'Add Gender'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="gender-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
          <Form.Item
            name="gender"
            label="Gender"
            rules={[{ required: true, message: 'Please enter a gender!' }]}
          >
            <Input placeholder="Enter gender " />
          </Form.Item>
          <Button type="primary" block htmlType="submit">
                {editingGender ? 'Update Gender' : 'Add Gender'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Gender List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default GenderMaster;
